import { render } from "./RichTextEditor.vue?vue&type=template&id=b1a27760&ts=true"
import script from "./RichTextEditor.vue?vue&type=script&lang=ts"
export * from "./RichTextEditor.vue?vue&type=script&lang=ts"

import "./RichTextEditor.vue?vue&type=style&index=0&id=b1a27760&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__